import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperEl = element.querySelector(".advantages-swiper");

    const swiper = new Swiper(swiperEl, {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 10,
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        breakpoints: {
            1500: {
                slidesOffsetAfter: 60,
                slidesOffsetBefore: 60,
                spaceBetween: 30,
            }
        },
        on: {
            init(swiper) {
                centerIfFewSlides(swiper);
            },
            resize(swiper) {
                centerIfFewSlides(swiper);
            }
        }
    });

    function centerIfFewSlides(swiper) {
        const wrapper = swiper.wrapperEl;
        const slides = swiper.slides;

        let totalWidth = 0;

        slides.forEach(slide => {
            totalWidth += slide.offsetWidth;
        });

        totalWidth += swiper.params.spaceBetween * (slides.length - 1);

        if (totalWidth < swiper.width) {
            wrapper.classList.add('is-centered');
        } else {
            wrapper.classList.remove('is-centered');
        }
    }

    element.swiper = swiper;
}
